import { type FC, type ReactElement, type ReactNode } from 'react'
import { type IntlShape, useIntl } from 'react-intl'

import { Link, Notification } from 'base-ui'

import { type DirectContactFormLoggedOutNotificationType } from '../../../model/directContactFormAccessorGetLoggedOutNotification'

const getNotificationText = (
  notificationType: DirectContactFormLoggedOutNotificationType,
  intl: IntlShape,
  link: (text: ReactNode[]) => ReactElement,
): ReactNode => {
  switch (notificationType) {
    case 'accountDeletion': {
      return intl.formatMessage(
        { id: 'direct.contact.form.account.delete.notification.text' },
        { link },
      )
    }
    case 'addressChange': {
      return intl.formatMessage(
        { id: 'direct.contact.form.address.change.notification.text' },
        { link },
      )
    }
    case 'advertising': {
      return intl.formatMessage(
        { id: 'direct.contact.form.advertising.notification.text' },
        { link },
      )
    }
    case 'nameChange': {
      return intl.formatMessage(
        { id: 'direct.contact.form.change.name.notification.text.new' },
        { link },
      )
    }
    default: {
      return null
    }
  }
}

export const DirectContactFormLoggedOutSubjectNotification: FC<{
  notificationType: DirectContactFormLoggedOutNotificationType
}> = ({ notificationType }) => {
  const intl = useIntl()
  const emailAddress = intl.formatMessage({
    id: 'contactForm.label.email.invitation.email',
  })
  const link = (text: ReactNode[]): ReactElement => (
    <Link className="text-dark-primary-max" href={`mailto:${emailAddress}`}>
      {text}
    </Link>
  )

  return (
    <Notification
      data-qa-id="contact-form-logged-out-subject-notification"
      icon
      severity="info"
      title={intl.formatMessage({
        id: 'message.center.thread.infoReplyTime.title',
      })}
    >
      {getNotificationText(notificationType, intl, link)}
    </Notification>
  )
}
